var _NearMe;
import React from 'react';
import Box from '@mui/material/Box';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import Icon from '@mui/material/Icon';
import NearMe from '@mui/icons-material/NearMe';
import { styled } from '@mui/material/styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function StickyButton(props) {
  var _link$trackingTag;
  var _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    link = props.link,
    onClick = props.onClick,
    _props$transitionTime = props.transitionTimeout,
    transitionTimeout = _props$transitionTime === void 0 ? 300 : _props$transitionTime;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (link == null ? void 0 : link.title) && /*#__PURE__*/_jsx(Root, {
      "aria-label": link.title,
      "data-name": (_link$trackingTag = link.trackingTag) != null ? _link$trackingTag : '',
      "data-testid": "".concat(testid, "-StickyButton"),
      onClick: onClick,
      role: "button",
      children: /*#__PURE__*/_jsx(Slide, {
        direction: "left",
        "in": true,
        timeout: transitionTimeout,
        children: /*#__PURE__*/_jsxs(StyledStack, {
          direction: "column",
          children: [/*#__PURE__*/_jsx(Box, {
            sx: {
              backgroundColor: '#369cd9 !important',
              height: 40,
              width: 40
            },
            children: /*#__PURE__*/_jsx(Icon, {
              sx: {
                color: 'white',
                height: 40,
                pt: '0.5rem',
                width: 40
              },
              children: _NearMe || (_NearMe = /*#__PURE__*/_jsx(NearMe, {}))
            })
          }), /*#__PURE__*/_jsx(TextContainer, {
            "data-testid": "".concat(testid, "-StickyButton-Text"),
            children: link.title
          })]
        })
      })
    })
  });
}
var Root = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    borderSpacing: '1px 1px !important',
    cursor: 'pointer',
    position: 'absolute',
    right: 2,
    top: 'max(calc(50vh - 91px),100px)',
    width: 41,
    zIndex: '2147483640 !important'
  };
});
var StyledStack = styled(Stack)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    backgroundColor: "".concat(theme.palette.common.white),
    borderColor: '#c6c6c6 !important',
    borderStyle: 'solid !important',
    borderWidth: '1px !important',
    boxShadow: '0 0px 7px -2px rgb(50 50 50 / 40%) !important',
    height: '100%'
  };
});
var TextContainer = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    backgroundColor: "".concat(theme.palette.common.white, " !important"),
    color: '#474747 !important',
    direction: 'ltr',
    fontSize: '18px',
    lineHeight: 'normal',
    paddingBottom: '0.5rem',
    paddingLeft: '0.5rem',
    paddingTop: '0.5rem',
    textOrientation: 'sideways',
    writingMode: 'vertical-lr'
  };
});